export const COMMON_DIRECTORY = {
  contacts: {
    collection: "commonContactPages",
    pageCapacity: 2000,
    label: "常用聯絡人",
  },
  addresses: {
    collection: "commonAddressPages",
    pageCapacity: 4000,
    label: "常用地址",
  },
};

export const DIRECTORY_VISIBLE_BATCH = 120;

export function directoryPageId(pageNo) {
  return String(Math.max(1, Number(pageNo) || 1)).padStart(4, "0");
}

export function directoryConfig(type) {
  return COMMON_DIRECTORY[type] || COMMON_DIRECTORY.contacts;
}

export function hydrateDirectoryPage(snapshot, pageNo) {
  if (!snapshot?.exists()) {
    return { exists: false, pageNo, items: [], rawItems: {} };
  }
  const data = snapshot.data() || {};
  const rawItems = data.items && typeof data.items === "object" && !Array.isArray(data.items)
    ? data.items
    : {};
  const items = Object.entries(rawItems).map(([id, item]) => ({
    id,
    ...(item && typeof item === "object" ? item : {}),
    __pageNo: pageNo,
  }));
  return {
    exists: true,
    pageNo,
    items,
    rawItems,
    itemCount: Number(data.itemCount) || items.length,
  };
}

export function serializeDirectoryItems(items = []) {
  return Object.fromEntries((items || []).map((item) => {
    const { id, ...payload } = item || {};
    delete payload.__pageNo;
    return [String(id), payload];
  }).filter(([id]) => id));
}

export function sortDirectoryItems(items = []) {
  return [...items].sort((left, right) => {
    const leftLabel = String(left?.name || left?.address || "").trim();
    const rightLabel = String(right?.name || right?.address || "").trim();
    return leftLabel.localeCompare(rightLabel, "zh-Hant");
  });
}

export function buildDirectoryPageData({ type, pageNo, items, uid, isNewPage = false, serverTimestampValue }) {
  const data = {
    schemaVersion: 1,
    pageNo,
    pageCapacity: directoryConfig(type).pageCapacity,
    itemCount: items.length,
    items: serializeDirectoryItems(items),
    updatedBy: uid || "",
    updatedAt: serverTimestampValue,
  };
  if (isNewPage) data.createdBy = uid || "";
  return data;
}
